<form [formGroup]="securityQForm" (ngSubmit)="SQ_onSubmit()">
  <div class="card bg-light">
    <div class="card-header">
      Security Questions
    </div>
    <div class="card-body">
      <div class="row">
        <div class="col-12">
          <div class="form-group mb-4">
            <button class="btn btn-default" type="button" *ngIf="!edit" (click)="clickEdit()">Edit</button>
            <button class="btn btn-success" type="submit" *ngIf="edit"
                    [disabled]="securityQForm.invalid || !uniqueAnswer()">
              Save
            </button>
            <button class="btn btn-cancel" type="button" *ngIf="edit" (click)="cancel()">Cancel</button>
          </div>
        </div>
      </div>

      <div class="row col-12" *ngIf="edit">
        <div class="form-group mb-4 input-required">
          <label class="font-italic">Select three unique secret questions and provide unique answers for each
            of them.</label>
        </div>
      </div>
      <!--
      TODO:
              Tried multiple times with FormArray but finally end up creating individual select drop downs. May have to look into this again and refactor with a FormArray.
      -->
      <div class="row form-group col-4" formGroupName="firstSQ">
        <span class="form-control-plaintext" *ngIf="!edit">{{getSecurityQuestionById(this.securityQForm.get('firstSQ').get('securityQuestionId').value)}}</span>

        <select formControlName="securityQuestionId" class="form-control" *ngIf="edit">
          <option *ngFor="let securityQuestion of filteredFirstfaq"
                  [ngValue]="securityQuestion.securityQuestionId">
            {{ securityQuestion.securityQuestion }}
          </option>
        </select>
      </div>
      <div class="row form-group col-4" formGroupName="firstSQ">
        <input formControlName="answer" id="answer_1" class="form-control" type="text"
               [ngClass]="{'form-control': edit, 'form-control-plaintext': !edit}" (input)="uniqueAnswer()" [readonly]="!edit">
      </div>

      <div class="row form-group col-4" formGroupName="secondSQ">
        <span class="form-control-plaintext" *ngIf="!edit">{{getSecurityQuestionById(this.securityQForm.get('secondSQ').get('securityQuestionId').value)}}</span>

        <select formControlName="securityQuestionId" class="form-control" *ngIf="edit">
          <option *ngFor="let securityQuestion of filteredSecfaq" [ngValue]="securityQuestion.securityQuestionId">
            {{ securityQuestion.securityQuestion }}
          </option>
        </select>
      </div>
      <div class="row form-group col-4" formGroupName="secondSQ">
        <input formControlName="answer" id="answer_2" class="form-control" type="text"
               [ngClass]="{'form-control': edit, 'form-control-plaintext': !edit}" (input)="uniqueAnswer()" [readonly]="!edit">
      </div>

      <div class="row form-group col-4" formGroupName="thirdSQ">
        <span class="form-control-plaintext" *ngIf="!edit">{{getSecurityQuestionById(this.securityQForm.get('thirdSQ').get('securityQuestionId').value)}}</span>

        <select formControlName="securityQuestionId" class="form-control" *ngIf="edit">
          <option *ngFor="let securityQuestion of filteredThirdfaq" [ngValue]="securityQuestion.securityQuestionId">
            {{ securityQuestion.securityQuestion }}
          </option>
        </select>
      </div>
      <div class="row form-group col-4" formGroupName="thirdSQ">
        <input formControlName="answer" id="answer_3" class="form-control" type="text"
               [ngClass]="{'form-control': edit, 'form-control-plaintext': !edit}" (input)="uniqueAnswer()" [readonly]="!edit">
      </div>
    </div>
  </div>
</form>

<!--<p>Form value: {{ securityQForm.value | json }}</p>
Form Status: {{ securityQForm.status }}-->

